<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Dedication</a></p>
<p class="toc sub"><a href="#/front03">Frontispiece</a></p>
<p class="toc sub"><a href="#/front04">Prologue</a></p>
<p class="toc"><a href="#/c01">A Regime of Fear</a></p>
<p class="toc"><a href="#/c02">Searching for a Savior</a></p>
<p class="toc"><span href="#/c03" title="Link target outside of Sample"><em>“Kullena Khaled Said”</em></span></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">Online and on the Streets</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">A Preannounced Revolution</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">January 25, 2011</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">My Name Is 41</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">The Dungeon</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">A Pharaoh Falls</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">Index</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">About the Author</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?71fc656b